import {isRequestError, RequestError} from "../../Model/RequestError";
import {ValidRaf} from "../../Model/Sales/ValidRaf";
import {joinUrl} from "../../Utilities/UriUtilities";
import {Reseller} from "../../Types/Reseller";
import {acceptHeader, executeWithErrorResponseHandling} from "../ApiUtilities";
import axios from "axios";
import {COUNTER_API_CALLS} from "../../Service/CounterMetricsProvider";

export const validateRafCode = async (
    reseller: Reseller,
    rafCode: string,
    apiDomain: string
): Promise<RequestError | ValidRaf> => {
    const endpoint = joinUrl(apiDomain, `/${reseller}/raf/validate/${encodeURIComponent(rafCode)}`)
    const headers = acceptHeader()

    const response = await executeWithErrorResponseHandling<ValidRaf>(() =>
        axios.get(endpoint, {headers: headers}))

    if (isRequestError(response)) {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/{reseller}/raf/validate/{rafCode}", "status": "error"}})
        return response
    } else {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/{reseller}/raf/validate/{rafCode}", "status": "success"}})
        return response.data
    }
}